﻿import { AttributeValue } from '@/shared/codeedit/codeEditFields.ts';

export class InputRegexValidator {
    private lengthBounds: { minLength: number; maxLength: number } | undefined;

    constructor(private readonly regexp: RegExp, private readonly message: string | null) {
        this.lengthBounds = InputRegexValidator.getLengthBounds(regexp);
    }

    get maxLength(): number | undefined {
        return this.lengthBounds?.maxLength;
    }

    get minLength(): number | undefined {
        return this.lengthBounds?.minLength;
    }

    get regExp(): RegExp {
        return this.regexp;
    }

    isInputValid(input: string): boolean {
        return this.regexp.test(input);
    }

    validate(input: AttributeValue): { error: string } | undefined {
        if (typeof input !== 'string') {
            return undefined;
        }

        if (!input) {
            return undefined;
        }

        if (this.isInputValid(input)) {
            return undefined;
        }

        if (this.minLength && input.length < this.minLength) {
            return { error: `Input cannot be shorter than ${this.minLength} characters` };
        }

        if (this.maxLength && input.length > this.maxLength) {
            return { error: `Input cannot be longer than ${this.maxLength} characters` };
        }

        let errorMessage = `Input does not match regex pattern "${this.regexp.toString()}"`;

        if (this.message) {
            errorMessage += ` (${this.message})`;
        }

        return { error: errorMessage };
    }

    private static getLengthBounds(regexp: RegExp): { minLength: number; maxLength: number } | undefined {
        const lengthRangePattern = /\^(?:\.|\[(?:\\\]|[^\]])*\]){(\s*\d*\s*),(\s*\d*\s*)}\$/;

        const match = regexp.toString().match(lengthRangePattern);

        if (!match)
            return undefined;
        return {
            minLength: parseInt(match[1]),
            maxLength: parseInt(match[2])
        };
    }
}
export function makeValidator(regex: RegExp | string, message?: string | null): InputRegexValidator {
    return new InputRegexValidator(new RegExp(regex), message ?? '');
}
